<template>
  <v-row>
    <v-col cols="12" lg="7" offset-lg="1">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-tabs
        v-model="tabModel"
        py-2
        height="60px"
        slider-color="white"
        background-color="#551738"
      >
        <v-tab :to="{ name: 'AddPension' }" :ripple="false" class="white--text">
          <v-icon class="white--text mr-2" small>money</v-icon>Pension
        </v-tab>
        <v-tab
          :to="{ name: 'AddInsurance' }"
          :ripple="false"
          class="white--text"
        >
          <v-icon class="white--text mr-2" small>medical_services</v-icon
          >Insurance
        </v-tab>
        <v-tab href="#custom" :ripple="false" class="white--text">
          <v-icon class="white--text mr-2" small>shuffle</v-icon>Custom
        </v-tab>
        <v-spacer />
        <v-btn
          depressed
          class="error mt-3 mr-2 white--text rounded-sm"
          @click="deleteDialog = true"
          >Delete</v-btn
        >
      </v-tabs>
      <v-tabs-items v-model="tabModel">
        <v-tab-item :value="'custom'">
          <v-card>
            <v-card-text>
              <v-form ref="form" valid="valid">
                <v-row>
                  <v-col class="pt-2" cols="12" lg="7">
                    <v-select
                        label="Category*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        :items="categories"
                        v-model="benefit.category"
                    />

                    <v-text-field
                      label="Title *"
                      validate-on-blur
                      :rules="[validationRules.required]"
                      clearable
                      v-model="benefit.title"
                    />

                    <v-text-field
                        label="Subheading *"
                        validate-on-blur
                        :rules="[validationRules.required]"
                        clearable
                        v-model="benefit.name"
                    />

                    <v-text-field
                        :rules="[validationRules.required]"
                        label="Provider name"
                        validate-on-blur
                        clearable
                        hint="Name of the company that offers this benefit"
                        v-model="benefit.provider_name"
                    />

                    <v-select
                        label="Location*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        :items="countries"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.location"
                    />
                    <v-textarea
                        label="Benefit details*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.information"
                    />

                    <v-file-input
                        v-model="fileInput"
                        show-size
                        label="Upload an image or logo"
                        accept="image/*"
                    ></v-file-input>

                    <v-select
                        label="Status*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        persistent-hint
                        hint="Only active benefits will be visible to employees"
                        :items="statuses"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.status"
                    />
                    <!--<v-text-field
                        label="Cost *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        hint="Annual cost of this benefit"
                        v-model="benefit.cost"
                        class="mt-4"
                    />
                    <v-text-field
                        label="Currency *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.currency"
                    />
                    <v-select
                        label="Unit *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        :items="units"
                        item-text="name"
                        item-value="value"
                        clearable
                        hint="Per unit cost of this benefit"
                        v-model="benefit.unit"
                    /> -->
                  </v-col>
                </v-row>
                <v-btn depressed class="save white--text ml-0 mt-3 rounded-sm" @click="save">Save</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-col class="px-1 pa-3" cols="12" lg="3">
      <v-card class="mt-15 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Find new benefits !
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="rounded-sm white--text action ml-2" depressed
          >Go to marketplace</v-btn
          >
        </v-card-actions>
      </v-card>

      <v-card class="mt-2 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Become a benefit provider !
          </div>
          <div class="grey--text text--darken-1 mt-2">
            Contribute to the community by offering your products and services to other users and companies.
            We only ask that you give back in the form of a unique offer or discount.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="rounded-sm white--text action ml-2" depressed
                 @click="manageOfferings"
          >Manage your offers
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card class="mt-2">
        <v-card-text>
          <div class="subheading font-weight-medium">Benefit preview</div>
          <div class="grey--text mt-1">
            Add details in the form to for live preview
          </div>
        </v-card-text>
        <v-img :src="benefit.url" height="240" v-if="benefit.url"/>
        <v-card-text primary-title>
          <div v-if="benefit">
            <h2>{{ benefit.name }}</h2>
            <div class="subheading mb-2">{{ benefit.title }}</div>
           <!-- <div class="body-2  mb-1">
              Cost : {{ benefit.cost }} {{ benefit.currency }} / {{ benefit.unit }}
            </div> -->
            <div class="body-2  mb-1">
              Provider : {{ benefit.provider_name }}
            </div>
            <div class="body-2  mb-1">
              Category : {{ benefit.category }}
            </div>
            <div class="body-2  mb-1">
              Location :
              {{ benefit.sub_location ? benefit.sub_location + ', ' : '' }}
              {{ benefit.location ? benefit.location : '' }}
            </div>
          </div>
          <div>
            <div class="body-2 grey--text mt-4 text--darken-1">
              {{ benefit.information }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer/>
          <span>Are you sure?</span>
          <v-spacer/>
        </v-card-title>
        <v-divider/>
        <v-card-text class="my-2 text-xs-center">
          This benefit will be deleted. You cannot recover this operation
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn color="success" text @click="deleteDialog = !deleteDialog">cancel</v-btn>
          <v-spacer/>
          <v-btn color="error" text @click="deleteEntity">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapGetters}  from 'vuex';

import {Actions}     from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component}   from '@/views/component';
import {Constants}   from '@/views/constants';

export default {
  name: Component.Protected.Benefit.Custom.Edit,
  data: () => ({
    tabModel: 'custom',
    endDateModal: false,
    startDateModal: false,
    breadcrumbs: Breadcrumbs.Benefit.Custom.Edit,
    benefit: [],
    statuses: Constants.Benefits.Status.Obj,
    valid: false,
    categories: Constants.Benefits.Category.All,
    //units: Constants.Benefits.Unit.Obj,
    deleteDialog: false,
    fileInput: [],
  }),
  computed: {
    ...mapGetters(["userInfo", "companyInfo", "countries"]),
  },
  methods: {
    manageOfferings() {
      this.$router.push({name: Component.Protected.Benefit.Provider.Info});
    },
    goBack() {
      this.$router.go(-1);
    },
    init() {
      this.benefit = {
        //cost: '',
        //unit: Constants.Benefits.Unit.Person,
        location: this.companyInfo.location,
        sub_location: '',
        information: '',
        name: '',
        provider_id: null,
        provider_name: '',
        status: Constants.Benefits.Status.Active,
        title: '',
        type: Constants.Benefits.Type.B2C,
        url: '',
        category: '',
        currency: '',
      };
      this.categories = Constants.Benefits.Category.All;
      //this.units = Constants.Benefits.Unit.All;
      this.deleteDialog = false;
    },
     save() {
      if (this.$refs.form.validate()) {
        //Logo is uploaded
        if (this.fileInput != ""){
        const fileName = `company/${this.userInfo.namespace}/benefit/${this.fileInput.name.replaceAll(" ", "_")}`
        const data = {
          action: 'editBenefit',
          fileName: fileName,
          metadata: {
            customMetadata: {
              namespace: this.userInfo.namespace,
              uid: this.userInfo.uid,
              type: "image",
            },
          },
          payload: {...this.benefit, cost: parseFloat(this.benefit.cost), url: ""},
          id: this.$route.params.id,
          content: this.fileInput,
        };

        this.$store
          .dispatch(Actions.Firebase.UploadImage, data)
          .then(() => {
            this.$router.push({name: Component.Protected.Benefit.List});
          })
          .catch((err) => {
            console.error(Constants.Benefits.Messages.Error.Edit, err);
            this.snackbar = true;
            this.snackbarMessage = Constants.Benefits.Messages.Error.Edit;
          })
          .finally(() => {
            this.fileInput = null;
          });
          return;
        }
        //Logo is not uploaded
        const data = {
            id: this.$route.params.id,
            data: {...this.benefit, cost: parseFloat(this.benefit.cost)}
          };
        this.$store.dispatch(Actions.Benefits.Edit, data).then(() => {
          this.$router.push({name: Component.Protected.Benefit.List});
        }).catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Edit, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Edit;
        });
      }
    },
    deleteEntity() {
      if (!this.$route.params.id || this.userInfo.role !== Constants.Roles.HR) {
        return false;
      }
      this.deleteDialog = false;
      this.$store.dispatch(Actions.Benefits.Delete, this.$route.params.id).then(() => {
          this.$router.push({ name: Component.Protected.Benefit.List });
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Delete, err);
          this.snackbarMessage = Constants.Benefits.Messages.Error.Delete;
          this.snackbar = true;
        });
    },
    getBenefit() {
      this.$store.dispatch(Actions.Benefits.Get, this.$route.params.id).then((r) => {
        if (r.status === 200) {
          if (!r.data) {
            this.$router.push({name: Component.Protected.Benefit.List});
            return false;
          }
          this.benefit = r.data;
        }
      }).catch((err) => {
        console.error(Constants.Benefits.Messages.Error.Get, err);
        this.snackbar = true;
        this.snackbarMessage = Constants.Benefits.Messages.Error.Get;
      });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR || !this.$route.params.id) {
        this.$router.push({ name: Component.Protected.Benefit.List });
      }
      this.init();
      this.getBenefit();
    },
  },
  created() {
    if (this.userInfo && this.companyInfo && this.countries) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
* >>> div.v-tabs__container {
  height: 60px !important;
  padding-left: 10px;
}
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}
* >>> div.v-date-picker-table {
  height: 200px !important;
}
* >>> div.v-item-group {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>